// extracted by mini-css-extract-plugin
export var active = "_49-7";
export var container = "_49-0";
export var evenWidth = "_49-4";
export var large = "_49-5";
export var outlet = "_49-8";
export var slide = "_49-2";
export var small = "_49-6";
export var tab = "_49-3";
export var tabs = "_49-1";